$(function() {
  $('.article-cart-slider').slick({
    //variableWidth: true, // スライド幅の自動計算を無効化
    arrows: true,
    autoplay: true,
    swipeToSlide: true,
    touchThreshold: 10,
    speed: 500,
    autoplaySpeed: 4e3,
    adaptiveHeight: false,
    dots: true,
    slidesToShow: 1,
    pauseOnHover: !1,
    pauseOnFocus: !1
  });
});